module.exports = __webpack_public_path__ + "static/media/backdrop.2ca167dc.png";